import React from 'react'
import { FaMagic } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/generate.less'

type GenerateControlProps = {
  onClick: () => void
  isFetching?: boolean | undefined
  failed?: boolean | undefined
  isFailed?: boolean | undefined
}

const GenerateControl = ({ onClick, isFetching }: GenerateControlProps) => {
  const handleClick = () => {
    if (isFetching) {
      return
    }
    onClick()
  }

  return (
    <div className={cn('control', 'generate')} data-graph-type="control" title="Generate Content">
      <a className={cn('icon', { disabled: isFetching })} onClick={handleClick}>
        <FaMagic aria-hidden />
        <span className="sr-only">Generate</span>
      </a>
    </div>
  )
}

export default GenerateControl
